<template>
    <div :class="['popup-toast', {'on': isShowToast}]" v-if="isShowToast2">
        <div class="container">
            <img v-if="isSuccess" src="../assets/images/toast_success_pic.svg" >
            <p v-if="title">{{title}}</p>
            <span v-if="content">{{content}}</span>
        </div>
    </div>
</template>

<script>
    import "@/assets/stylesheets/popup.scss"

    export default {
        props: {},
        data() {
            return {
                isShowToast: false,
                isShowToast2: false,
                title: '',
                content: '',
                isSuccess: false,
            }
        },
        methods: {
            showToast(title = '温馨提示', content, isSuccess = false, time = 2000) {
                this.title = title
                this.content = content
                this.isSuccess = isSuccess
                this.isShowToast2 = true
                setTimeout(() => {
                    this.isShowToast = true
                }, 10)

                setTimeout(() => {
                    this.isShowToast = false
                    setTimeout(() => {
                        this.isShowToast2 = false
                    }, 300)
                }, time)
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Toast.vue